import { ListItemButton } from '@mui/material';
import SearchItemText from './SearchItemText';

export default function SearchEntryButton({ onClick, title, isPageShowing, query, pageNumber, pageNumberText }) {
    return (
        <ListItemButton
            onClick={onClick}
        >
            <SearchItemText
                isPageShowing={isPageShowing}
                title={title}
                query={query}
                pageNumber={pageNumber}
                pageNumberText={pageNumberText}
            />
        </ListItemButton>
    );
}